<template>
  <div>
    <ul
      v-for="(item) in list"
      :key="item.name"
      :class="$style.list"
    >
      <li :class="$style.nameList">
        <a
          @click="handleClickAction(item)"
        >{{ item.name }}</a>
      </li>
      <li :class="$style.listValue">
        <span>
          {{ item.value }}
        </span>
      </li>
      <li :class="$style.listKey">
        <span>
          -
        </span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'GroupList',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleClickAction(item) {
      this.$emit('handleClickAction', item);
    },
  },

};
</script>

<style scoped module>

.list {
  display: flex;
  list-style: none;
  padding: 0.6rem;
}

.listItem:last-of-type {
  border-bottom: none;
}

.nameList {
  cursor: pointer;
  flex: auto;
  font-size: 1.1rem;
  font-weight: bold;
  max-width: 15rem;
}

.listKey {
  padding-left: 10rem;
}

.listValue {
  font-size: 1.2rem;
  font-weight: bold;
  max-width: 1rem;
  padding-left: 1rem;
}

</style>
